import React from 'react'
// libs
import { useSelector } from 'react-redux'
import { formValueSelector } from 'redux-form'
// icons
import PlusIcon from '@mui/icons-material/Add'
import IconButton from '@mui/material/IconButton'
// constants
import { Forms } from 'constants/forms'
// types
import { IField } from 'types/graphql'
import { FilterField } from '../../index'
// themes
import { colors } from 'themes/index'
// components
import { ReduxRadioGroup } from 'components/FormElements'
// store
import { responseTypesSelector } from 'store/reducers/riskTemplates'
// views
import { ArrowIcon, FieldSettingsWrapper, IconWrapper, FieldLabel } from './views'
// utils
import { getOptions, getValueField } from '../../utils'

interface Props {
  field: IField
  addField: (field: FilterField) => void
  clearField: () => void
}

const selector = formValueSelector(Forms.RISK_VIEW_FILTER_FORM)

const Field: React.FC<Props> = ({ field, addField, clearField }) => {
  const responseTypeSets = useSelector(responseTypesSelector)

  const value = useSelector((state) => selector(state, `${field.id}.value`))
  const action = useSelector((state) => selector(state, `${field.id}.action`))

  const onAddClick = () => {
    addField({
      value,
      action,
      id: field.id,
      name: field.label,
      fieldType: field.fieldType,
      // @ts-ignore
      riskTemplateId: field.riskTemplateId
    })
  }

  return (
    <FieldSettingsWrapper>
      <IconWrapper>
        <ArrowIcon onClick={clearField} htmlColor={colors.purple500} />
      </IconWrapper>
      <FieldLabel>{field.label}</FieldLabel>
      <ReduxRadioGroup name={`${field.id}.action`} options={getOptions(field)} />
      {getValueField({ field, name: `${field.id}.value`, responseTypeSets })}
      <IconButton onClick={onAddClick} disabled={!value || !action}>
        <PlusIcon htmlColor={!value || !action ? colors.gray280 : colors.purple500} />
      </IconButton>
    </FieldSettingsWrapper>
  )
}

export default Field
